import { render, staticRenderFns } from "./SubPerimeterForm.vue?vue&type=template&id=e48ed958"
import script from "./SubPerimeterForm.vue?vue&type=script&lang=js"
export * from "./SubPerimeterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports